import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild
} from '@angular/core';
import { Chart, registerables } from 'chart.js';
import moment from 'moment';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { MasterDataSeriveService } from '../../../../Services/master-data-serive.service';
import {
  Categories,
  DateRangeModel,
  EmpReportQty,
  EmpReportsTotal,
  EmpReportTable,
  LoginModel,
  MainDepartment,
  RowData,
  Stores,
  subCategories
} from '../../../../Models/ApplicationModels';
import { DatePipe } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { AdminBreadcrumbsService } from '../../admin-services/admin-breadcrumbs.service';
import { parse } from 'path';
import { ExportExcelService } from '../../../../Services/export-excel.service';
import { OverrideStatus } from 'src/app/enum/enum';
import { UserserviceService } from 'src/app/Services/userservice.service';
import { CustomToastsService } from 'src/app/Services/custom-toasts.service';
import { ProductionCycle } from '../../company-config/WeekColors/models/week-color.model';
import { WeekColorService } from '../../company-config/WeekColors/services/week-color.service';
@Component({
  selector: 'app-emp-reports',
  templateUrl: './emp-reports.component.html',
  styleUrls: ['./emp-reports.component.css']
})
export class EmpReportsComponent {
  @ViewChild('dateRange') dateRange!: ElementRef<HTMLElement>;
  @ViewChild('projection') projection!: ElementRef<HTMLElement>;
  @ViewChild('totalItem') totalItem!: ElementRef<HTMLElement>;
  @ViewChild('preProduced') preProduced!: ElementRef<HTMLElement>;
  isDashboardTab: boolean = true;
  headerCheckboxSelected: boolean = false;
  gaugeValue = 0;
  gaugeLabel = 'goal achieved';
  gaugeAppendText = '%';
  gaugeColor: string = 'rgba(149, 164, 252, 1)';
  isSummary: boolean = false;
  charts: Chart[] = [];
  isEmployeLevelData: boolean = false;
  isProjectionData: boolean = false;
  isTotalValue: boolean = false;
  totalItemsCollected: number = 0;
  totalItemsPreProduced: number = 0;
  totalValueCollected: number = 0;
  totalItemCollectChart: any;
  totalItemPreProducedChart: any;
  projectionChartData: any;
  projectionChart: any = [];
  prevProjectionChart: any = [];
  projectionLabels: string[] = [];
  colorIndex: number = -1;
  reportType: string[] = ['store 1'];
  goalValueStr: string = 'Count';
  employeesList: any[] = [];
  selectedEmployeeNames: string[] = [];
  selectedEmployeeIds: number[] = [];
  selectedEmployeeIdStr: string = '0';
  employeeHeaderSelected: boolean = false;
  goalValue = [
    {
      goalValueID: 1,
      goalValue: 'Currency'
    },
    {
      goalValueID: 2,
      goalValue: 'Count'
    }
  ];
  empLevel = [
    {
      StoreID: 0,
      name: '',
      Qty: 0,
      GoalCnt: 0,
      totalAchieved: 0,
      color: '',
      bg: ''
    }
  ];
  empLevel2 = [
    {
      name: 'Archie',
      level: 93,
      color: '#95A4FC',
      bg: '#95A4FC33'
    },
    {
      name: 'Kari',
      level: 85,
      color: '#BAEDBD',
      bg: '#BAEDBD33'
    },
    {
      name: 'Theodore',
      level: 81,
      color: '#1C1C1C',
      bg: '#1C1C1C33'
    },
    {
      name: 'Vicky',
      level: 80,
      color: '#B1E3FF',
      bg: '#B1E3FF33'
    },
    {
      name: 'Garrett',
      level: 76,
      color: '#A8C5DA',
      bg: '#A8C5DA33'
    }
  ];
  goalValueID: number = 2;
  reportTypeText: string = 'Outlet';
  outletOne: string = 'NYC-01';
  outletTwo: string = 'NYC-03';
  reportTypeOption: string = 'Store 1';
  isUser: boolean = false;
  deptName: string = 'All departments';
  categoryName: string = 'All categories';
  subCategoryName: string = 'All subcategories';
  storeName: string = 'All stores';
  storeId: number = 0;
  deptNames: Array<string> = [];
  deptIDs: Array<number> = [];
  deptId: string = '0';
  categoryId: number = 0;
  subCategoryId: number = 0;
  startDate: any = '';
  endDate: any = '';
  reportHead: string = 'All departments / all categories';
  statData: any = [
    {
      title: 'Value',
      img: 'assets/pos/products/ic_upGrowth.svg',
      value: '$2.6k',
      growth: 6.08,
      background: '#E3F5FF'
    },
    {
      title: 'Pieces',
      img: 'assets/pos/products/ic_downGrowth.svg',
      value: '555',
      growth: 6.08,
      background: '#E5ECF6'
    },
    {
      title: 'Hours',
      img: 'assets/pos/products/ic_downGrowth.svg',
      value: '11.0',
      growth: 6.08,
      background: '#E3F5FF'
    },
    {
      title: '$/Hour',
      img: 'assets/pos/products/ic_upGrowth.svg',
      value: '555',
      growth: 6.08,
      background: '#E5ECF6'
    },
    {
      title: 'APOP',
      img: 'assets/pos/products/ic_upGrowth.svg',
      value: '$4.44',
      growth: 6.08,
      background: '#E3F5FF'
    }
  ];
  stores: Array<Stores> = [];
  mainDepartmentList: Array<MainDepartment> = [];
  categorieslist: Array<Categories> = [];
  subCategorieslist: Array<subCategories> = [];
  userInfo: LoginModel = new LoginModel();
  noTableData: boolean = false;
  disableCategory: boolean = true;
  disableSubCategory: boolean = true;
  goalIntervalID: number = 4;
  isGoalData: boolean = true;
  stackChartData: number[][] = [];
  stackChartDataPreProduced: number[][] = [];
  stackChartLabels: string[] = [];
  stackchartlabelsPreProduced: string[] = [];
  isTotalItemData: boolean = false;
  isPreProducedData: boolean = false;

  empReportPrices: any = [
    {
      name: 'Stores',
      prices: []
    }
  ];
  empReportPricesexcel: any = [
    {
      name: 'Stores',
      prices: []
    }
  ];
  MainStats = {
    qty: 0,
    totalHoursLogged: 0,
    value: 0,
    qtyGrowth: 0,
    valueGrowth: 0,
    apopGrowth: 0
  };
  empDashboardDetails: any = [];
  empReportsQtys: Array<EmpReportQty> = [];
  empReportsQtysexcel: Array<EmpReportQty> = [];
  tblReportsTotal: EmpReportsTotal = new EmpReportsTotal();
  tblReportsTotalExcel: EmpReportsTotal = new EmpReportsTotal();
  weekColorHeaderSelected: boolean = false;
  weekColor: string = 'All Week Colors';
  weekColorsList: Array<ProductionCycle> = [];
  productionCycleId: number = 0;
  showWeekColor: boolean = true;
  dateRangeModal: DateRangeModel = new DateRangeModel();
  @Output() dateRangeSelected = new EventEmitter<DateRangeModel>();
  isLoadingEmpDashboard: boolean = false;
  isLoadingTable: boolean = false;
  pageSize = 5;
  currentPage = 1;
  reportHasRun: boolean = false;

  constructor(
    private toaster: CustomToastsService,
    private masterService: MasterDataSeriveService,
    private datepipe: DatePipe,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private exportExcelService: ExportExcelService,
    private userservice: UserserviceService,
    private weekColorService: WeekColorService
  ) { }

  async ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Reports', link: 'demo' },
      { crumbName: 'Employee Report', link: '/admin/home/emp-report' }
    ]);

    this.userInfo = JSON.parse(localStorage.getItem('user')!);
    const productionScheduleType = (
      this.userInfo as any
    )?.productionScheduleType
      ?.toString()
      ?.trim()
      ?.toLowerCase();
    this.showWeekColor = productionScheduleType !== 'datespecific';
    this.getStores();
    if (this.showWeekColor) {
      this.getWeekColors();
    } else {
      this.productionCycleId = 0;
      this.weekColor = 'All Week Colors';
    }
    this.getMainDepartments();
    this.startDate = moment().format('MM-DD-YYYY');
    this.endDate = moment().format('MM-DD-YYYY');
    this.getEmployees();
    this.productionCycleId = 0;
    this.getEmployees();
    await this.getEmpDashboard();
  }

  /*date range picker */
  public options: any = {
    locale: {
      format: 'MM/DD/YYYY',
      separator: ' - '
    },
    alwaysShowCalendars: true,
    showDropdowns: false,
    showCustomRangeLabel: false,
    maxDate: new Date(),
    autoApply: true,
    isInvalidDate: () => true, // Mark all dates as invalid,
    ranges: {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'This Week': [moment().startOf('week'), moment()],
      'Last Week': [
        moment().subtract(1, 'week').startOf('week'),
        moment().subtract(1, 'week').endOf('week')
      ],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month')
      ]
    },
    opens: 'left'
  };

  public selectedDate() {
    this.startDate = this.dateRangeModal.fromDate;
    this.endDate = this.dateRangeModal.toDate;
    this.getEmployees();
    switch (this.dateRangeModal.Measure) {
      case 'hour':
        this.goalIntervalID = 4;
        this.isGoalData = true;
        break;
      case 'day':
        this.goalIntervalID = 1;
        this.isGoalData = true;
        break;
      case 'week':
        this.goalIntervalID = 2;
        this.isGoalData = true;
        break;
      case 'month':
        this.goalIntervalID = 3;
        this.isGoalData = true;
        break;
      case 'custom':
        this.goalIntervalID = 0;
        this.isGoalData = false;
        break;
      default:
        return;
        break;
    }
  }

  openCalender() {
    if (this.dateRange) {
      this.dateRange.nativeElement.click();
    }
  }

  toggleDashboardTabs(opt: boolean) {
    if (this.isDashboardTab !== opt) {
      this.isDashboardTab = opt;
      // Switching the view must not auto-fetch. The user must click Run Report
      // to load data for the newly selected tab. Existing report state is kept.
    }
  }

  /*Emp report methods*/

  getStores() {
    let user = this.masterService.getUserDetailsFromStorage();
    this.masterService.getallstores(user.companyID).subscribe((res) => {
      if (Array.isArray(res)) {
        for (let item of res) {
          this.stores.push(item);
        }
      }
    });
  }
  getEmployees() {
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    this.masterService
      .getEmployeesWithReportActivity(
        this.userInfo.companyID,
        formattedStartDate,
        formattedEndDate
      )
      .subscribe((res: any) => {
        this.employeesList = res;

        // Drop selections that no longer worked in the newly selected date range.
        const availableIds = new Set(this.employeesList.map((e) => e.id));
        this.selectedEmployeeIds = this.selectedEmployeeIds.filter((id) =>
          availableIds.has(id)
        );
        this.selectedEmployeeNames = this.employeesList
          .filter((e) => this.selectedEmployeeIds.includes(e.id))
          .map((e) => e.fullName);
        this.selectedEmployeeIdStr =
          this.selectedEmployeeIds.length > 0
            ? this.selectedEmployeeIds.join(',')
            : '0';

        this.employeesList.forEach(
          (emp) => (emp.isSelected = this.selectedEmployeeIds.includes(emp.id))
        );
        this.employeeHeaderSelected =
          this.employeesList.length > 0 &&
          this.selectedEmployeeIds.length === this.employeesList.length;
      });
  }
  selectAllEmployees() {
    this.employeeHeaderSelected = false;
    this.selectedEmployeeNames = [];
    this.selectedEmployeeIds = [];
    this.selectedEmployeeIdStr = '0';
    this.employeesList.forEach((emp) => (emp.isSelected = false));
    this.updateChart();
  }

  toggleAllEmployeesCheckboxes() {
    this.employeeHeaderSelected = !this.employeeHeaderSelected;
    this.selectedEmployeeNames = [];
    this.selectedEmployeeIds = [];
    this.employeesList.forEach((emp) => {
      emp.isSelected = this.employeeHeaderSelected;
      if (this.employeeHeaderSelected) {
        this.selectedEmployeeNames.push(emp.fullName);
        this.selectedEmployeeIds.push(emp.id);
      }
    });
    this.selectedEmployeeIdStr = this.selectedEmployeeIds.length > 0
      ? this.selectedEmployeeIds.join(',')
      : '0';
    this.updateChart();
  }
  getMainDepartments() {
    this.masterService.getDepartmentsProduction(false, 0).subscribe(
      (Response: any) => {
        this.mainDepartmentList = Response as MainDepartment[];
      },
      (err) => { }
    );
  }

  async getCategoriesByDeptId(deptIds: number[]) {
    try {
      const results = await Promise.all(deptIds.map(id =>
        firstValueFrom(this.masterService.getCategoriesByDeptUserID(id, this.userInfo.userId, false, 0))
      ));
      const flatList = (results.filter(Boolean) as Categories[][]).flat();
      this.categorieslist = flatList.filter((cat, idx) =>
        flatList.findIndex(c => c.categoryId === cat.categoryId) === idx
      );
      this.categoryName = 'All categories';
      this.resetSubCategory();
    } catch (err) {
      console.error(err);
    }
  }

  getSubCategoriesByCategoryId(categoryId: number) {
    this.masterService
      .getProductionSubCategory(
        this.userInfo.companyID,
        this.deptIDs[this.deptIDs.length - 1],
        categoryId
      )
      .subscribe((res) => {
        this.subCategoryName = 'All subcategories';
        this.subCategorieslist = res as subCategories[];
      });
  }

  resetSubCategory() {
    this.subCategorieslist = [];
    this.subCategoryId = 0;
    this.subCategoryName = 'All subcategories';
    this.disableSubCategory = true;
  }

  getWeekColors() {
    let user = this.masterService.getUserDetailsFromStorage();
    this.weekColorService
      .getProductionCycles(user.companyID)
      .subscribe((res) => {
        this.weekColorsList = res as ProductionCycle[];
        this.weekColorsList = this.weekColorsList.filter(
          (item) => item.status === OverrideStatus.Active
        );
      });
  }

  //toggleAllCheckboxes() {
  //  ;
  //  /*this.deptName = 'All department';*/
  //  this.headerCheckboxSelected = !this.headerCheckboxSelected;
  //  if (!this.disableCategory)
  //    this.disableCategory = true

  //  // Update the selectedDepartmentIDs array based on headerCheckboxSelected state
  //  if (this.headerCheckboxSelected) {
  //    /* this.goal.isSelected = true;*/
  //    this.deptIDs = this.mainDepartmentList.map(goal => goal.departmentId);
  //  }
  //  else {
  //    this.deptIDs = [];
  //    /*this.goal.gIsSelected = false;*/
  //  }
  //  if (this.deptIDs.length) {
  //    this.deptId = this.deptIDs.join(', ');
  //  } else {
  //    this.deptName = 'All departments'
  //    this.deptId = '0';

  //  }
  //  this.updateChart();
  //}

  toggleAllCheckboxes() {
    this.headerCheckboxSelected = !this.headerCheckboxSelected;

    if (!this.disableCategory) this.disableCategory = true;
    this.resetSubCategory();

    // Set all department checkboxes based on the select all checkbox

    this.deptNames = [];

    this.mainDepartmentList.forEach((dept) => {
      dept.isSelected = this.headerCheckboxSelected;

      if (this.headerCheckboxSelected) {
        this.deptNames.push(dept.departmentDescr);
      }
    });

    if (!this.headerCheckboxSelected) this.deptNames = [];

    //Update selected department IDs
    this.deptIDs = this.headerCheckboxSelected
      ? this.mainDepartmentList.map((dept) => dept.departmentId)
      : [];

    if (this.deptIDs.length) {
      if (this.deptIDs.length == this.mainDepartmentList.length)
        this.deptId = '0';
      this.deptName = 'All departments';
    } else {
      this.deptName = 'All departments';
      let allIDs = this.mainDepartmentList.map((dept) => dept.departmentId);
      this.deptId = '0';
    }
  }

  toggleAllColors() {
    this.weekColorHeaderSelected = !this.weekColorHeaderSelected;
    if (!this.disableCategory) this.disableCategory = true;
    if (!this.weekColorHeaderSelected) this.productionCycleId = 0;
  }

  selectAllStores() {
    this.storeName = 'All stores';
    this.storeId = 0;
  }

  selectAllcolors() {
    this.weekColor = 'All Week Colors';
    this.productionCycleId = 0;
  }

  selectAllcategories() {
    if (this.categorieslist.length) {
      let index = this.reportHead.indexOf('/');
      if (index !== -1) {
        this.reportHead = this.reportHead.substring(0, index);
      }
      this.categoryName = 'All categories';
      this.categoryId = 0;
      this.resetSubCategory();
    }
  }

  selectAllSubcategories() {
    if (this.subCategoryId) {
      let index = this.reportHead.lastIndexOf('/');
      if (index !== -1) {
        this.reportHead = this.reportHead.substring(0, index).trim();
      }
    }
    this.subCategoryName = 'All subcategories';
    this.subCategoryId = 0;
  }

  setFilterNames(filterObj: any, option: number) {
    if (option === 1) {
      this.storeName = filterObj.storeName;
      this.storeId = filterObj.storeId;
    }
    if (option === 2) {
      this.categoryName = 'All categories';
      this.categoryId = 0;
      this.categorieslist = [];
      this.resetSubCategory();

      const nameIndex = this.deptNames.findIndex(
        (item) => item === filterObj.departmentDescr
      );
      this.reportHead = '';
      if (nameIndex !== -1) {
        this.deptNames.splice(nameIndex, 1);
        this.reportHead = this.deptNames[nameIndex - 1];
      } else {
        this.deptNames.push(filterObj.departmentDescr);
        this.reportHead = filterObj.departmentDescr;
      }

      // this.deptIDs.push(filterObj.departmentId);
      if (this.deptNames.length > 1) {
        this.deptName =
          this.deptNames.slice(0, 1) + ' +' + `${this.deptNames.length - 1}`;
      } else {
        this.deptName = this.deptNames.join(', ');
      }

      const iDIndex = this.deptIDs.indexOf(filterObj.departmentId);

      // If departmentId is already present, remove it from this.deptIDs
      if (iDIndex !== -1) {
        this.deptIDs.splice(iDIndex, 1);
      } else {
        this.deptIDs.push(filterObj.departmentId);
      }

      this.disableCategory = false;

      if (this.deptIDs.length) {
        this.deptId = this.deptIDs.join(', ');

        if (this.deptIDs && this.deptIDs.length > 0) {
          this.getCategoriesByDeptId(this.deptIDs);
        }
      } else {
        this.deptName = 'All departments';
        this.deptId = '0';
        this.disableCategory = true;
      }
    }
    if (option === 3) {
      if (this.categoryName) {
        this.reportHead = (this.reportHead ?? '').split('/')[0].trim();
      }

      this.categoryName = filterObj.categoryName;
      this.categoryId = filterObj.categoryId;
      this.reportHead += ' / ' + filterObj.categoryName;

      this.resetSubCategory();
      this.disableSubCategory = false;
      this.getSubCategoriesByCategoryId(this.categoryId);
    }
    if (option === 4) {
      this.goalValueStr = filterObj.goalValue;
      this.goalValueID = filterObj.goalValueID;
    }
    if (option == 5) {
      this.weekColor = filterObj.displayName;
      this.productionCycleId = filterObj.id;
    }
    if (option === 6) {
      this.subCategoryName = filterObj.subCategoryName;
      this.subCategoryId = filterObj.subCategoryID || filterObj.subCategoryId;
      this.reportHead += ' / ' + filterObj.subCategoryName;
    }
    if (option === 7) {
      filterObj.isSelected = !filterObj.isSelected;

      const nameIdx = this.selectedEmployeeNames.indexOf(filterObj.fullName);
      if (nameIdx !== -1) {
        this.selectedEmployeeNames.splice(nameIdx, 1);
      } else {
        this.selectedEmployeeNames.push(filterObj.fullName);
      }

      const idIdx = this.selectedEmployeeIds.indexOf(filterObj.id);
      if (idIdx !== -1) {
        this.selectedEmployeeIds.splice(idIdx, 1);
      } else {
        this.selectedEmployeeIds.push(filterObj.id);
      }

      this.selectedEmployeeIdStr = this.selectedEmployeeIds.length > 0
        ? this.selectedEmployeeIds.join(',')
        : '0';

      this.employeeHeaderSelected =
        this.selectedEmployeeIds.length === this.employeesList.length;
    }
  }

  runReport() {
    this.reportHasRun = true;
    this.updateChart();
  }

  get isRunning(): boolean {
    return this.isLoadingEmpDashboard || this.isLoadingTable;
  }

  async updateChart() {
    if (this.isDashboardTab) {
      this.destroyCharts();
      await this.getEmpDashboard();
    } else {
      await this.getEmpReporTable();
    }
  }

  days: number = 0;

  /* get employee dashboard*/
  async getEmpDashboard() {
    this.destroyCharts();
    this.isLoadingEmpDashboard = true;
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    if (this.deptIDs.length > 1 || this.deptIDs.length == 0) {
      this.categoryId = 0;
      this.subCategoryId = 0;
    }
    this.masterService
      .getEmpDashboard(
        this.userInfo.companyID,
        this.storeId,
        this.deptId,
        this.goalValueID,
        this.goalIntervalID,
        this.categoryId,
        formattedStartDate,
        formattedEndDate,
        this.productionCycleId,
        this.selectedEmployeeIds,
        this.subCategoryId
      )
      .subscribe({
        next: (res: any) => {
          this.empDashboardDetails = res as any[];

          /* Ensure stats exist and are not empty */
          if (
            res.stats &&
            res.stats.length > 0 &&
            res.stats[0]?.qty != null &&
            res.stats[0]?.value != null
          ) {
            const mainStats = res.stats[0];
            this.MainStats = mainStats;

            const prevStats = res.prevStat[0] ?? { qty: 0, value: 0 };

            const currentApop = mainStats.value / mainStats.qty;
            const prevApop =
              prevStats?.value && prevStats?.qty
                ? prevStats.value / prevStats.qty
                : 0;

            this.MainStats.totalHoursLogged = parseFloat(
              (this.MainStats.totalHoursLogged ?? 0).toFixed(2)
            );

            const prev = res.prevStat?.[0] || {};
            const prevQty = prev.qty ?? 0;

            this.MainStats.qtyGrowth = parseFloat(
              (
                (((mainStats.qty ?? 0) - prevQty) / (prevQty || 1)) *
                100
              ).toFixed(2)
            );

            this.MainStats.valueGrowth = parseInt(
              (
                (((mainStats?.value ?? 0) - (prevStats?.value ?? 0)) /
                  Math.max(prevStats?.value ?? 1, 1)) *
                100
              ).toFixed(2)
            );
            this.MainStats.apopGrowth = parseInt(
              (
                (((currentApop ?? 0) - (prevApop ?? 0)) /
                  Math.max(prevApop ?? 1, 1)) *
                100
              ).toFixed(2)
            );
          } else {
            console.warn('stats is empty or missing, setting default values.');
            this.setDefaultMainStats();
          }

          /*gauge*/
          if (res.goal?.length) {
            let totalGoalCount = 0;
            let totalAchieved = 0;
            res.goal.forEach((item: any) => {
              totalGoalCount += item.goalCount || item.GoalCnt || 0;
              totalAchieved += item.qty || item.Qty || 0;
            });
            this.gaugeValue = totalGoalCount > 0
              ? parseFloat(((totalAchieved / totalGoalCount) * 100).toFixed(2))
              : 0;
          } else if (res.goalAvg?.length) {
            const goalAvg = res.goalAvg;
            let goalCnt: any = 0;
            let totalAchieved: any = 0;
            goalAvg.forEach((item: any) => {
              goalCnt += item.goalCount || item.GoalCnt || 0;
              totalAchieved += item.qty || item.Qty || 0;
            });
            this.gaugeValue = goalCnt > 0
              ? parseFloat(((totalAchieved / goalCnt) * 100).toFixed(2))
              : 0;
          } else {
            this.gaugeValue = 0;
          }

          /*store / employee level*/
          this.empLevel = this.empDashboardDetails.goal;
          if (this.empDashboardDetails.goal.length) {
            this.isEmployeLevelData = true;
          } else {
            this.isEmployeLevelData = false;
          }
          this.empLevel.forEach((item: any) => {
            item.totalAchieved = parseFloat(
              ((item.qty! / item.goalCount) * 100).toFixed(2)
            );
            item.color = this.randomColor();
            item.bg = item.color + '33';
          });

          if (this.empDashboardDetails.projection.length) {
            this.isProjectionData = true;
            const startDate = this.datepipe.transform(
              this.startDate,
              'yyyy-MM-dd'
            );
            const endDate = this.datepipe.transform(this.endDate, 'yyyy-MM-dd');
            if (startDate === endDate) {
              this.empDashboardDetails.projection.forEach((item: any) => {
                this.projectionLabels.push(
                  new Date(item.createdDt).toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    hour12: true
                  })
                );
              });
              this.projectionLabels = Array.from(
                new Set(this.projectionLabels)
              );
              this.projectionChart = this.createProjectionChartByHours(
                this.empDashboardDetails.projection
              );
              this.prevProjectionChart = this.createProjectionChartByHours(
                this.empDashboardDetails.prevprojection
              );
            } else {
              const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
              this.projectionLabels = this.empDashboardDetails.projection.map(
                (item: { createdDt: string | number | Date }) => {
                  const date = new Date(item.createdDt);
                  const day = days[date.getDay()];
                  const dayOfMonth = date.getDate();
                  return `${day} ${dayOfMonth}`;
                }
              );
              this.projectionLabels = Array.from(
                new Set(this.projectionLabels)
              );
              this.prevProjectionChart = this.createProjectionChart(
                this.empDashboardDetails.prevprojection
              );
              this.projectionChart = this.createProjectionChart(
                this.empDashboardDetails.projection
              );
            }
          } else {
            this.isProjectionData = false;
          }

          if (this.empDashboardDetails.totalValue.length) {
            this.isTotalValue = true;
            this.empDashboardDetails.totalValue.forEach((item: any) => {
              this.totalValueCollected += item.totalValue;
            });
          } else {
            this.isTotalValue = false;
          }
          if (this.empDashboardDetails.totalItems.length) {
            this.isTotalItemData = true;
          } else {
            this.isTotalItemData = false;
          }
          this.isPreProducedData = this.empDashboardDetails.totalPreProduced
            .length
            ? true
            : false;

          this.stackChartLabels = Array.from(
            new Set(
              this.empDashboardDetails.totalItems.map(
                (item: { name: any }) => item.name
              )
            )
          );
          this.stackchartlabelsPreProduced = Array.from(
            new Set(
              this.empDashboardDetails.totalPreProduced.map(
                (item: { name: any }) => item.name
              )
            )
          );
          this.generateStackChartData();
          this.generateStackChartDataPreProduced();
          this;
          if (this.stackChartData.length) {
            this.empDashboardDetails.totalItems.forEach((item: any) => {
              this.totalItemsCollected += item.qty;
            });
          }
          setTimeout(() => {
            this.renderChart();
          }, 0);
        },
        error: (err) => {
          this.isLoadingEmpDashboard = false;
        },
        complete: () => {
          this.isLoadingEmpDashboard = false;
        }
      });
  }

  /* Function to reset MainStats */
  setDefaultMainStats() {
    this.MainStats = {
      qty: 0,
      totalHoursLogged: 0,
      value: 0,
      qtyGrowth: 0,
      valueGrowth: 0,
      apopGrowth: 0
    };
    this.days = 0;
  }

  //getDaysFromDates() {
  //
  //  if (!this.startDate || !this.endDate) this.days = 0; // Handle undefined/null dates

  //  const startDateObj = new Date(this.startDate);
  //  const endDateObj = new Date(this.endDate);

  //  // Calculate the difference in milliseconds
  //  const differenceInMs = endDateObj.getTime() - startDateObj.getTime();

  //  // Convert milliseconds to days
  //  const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

  //  this.days = differenceInDays;
  //}

  /*  get employee table report*/
  async getEmpReporTable() {
    this.isLoadingTable = true;
    console.log('isLoadingTable', this.isLoadingTable);
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );

    try {
      const res: any = await firstValueFrom(
        this.masterService.getEmpReportTableData(
          this.userInfo.companyID,
          this.storeId,
          this.deptId,
          this.categoryId,
          formattedStartDate,
          formattedEndDate,
          this.productionCycleId,
          this.selectedEmployeeIds,
          this.subCategoryId
        )
      );

      this.pageSize = 5;
      this.currentPage = 1;

      if (res && res.report && res.report.length) {
        this.noTableData = false;
        this.empReportPrices[0].name =
          this.storeId === 0 ? 'Stores' : 'Employee';
        this.formateReportExcelData(res);
        this.formateReportTableData(res);
      } else {
        this.noTableData = true;
        // Clear any previously loaded rows so a subsequent empty result
        // doesn't leave a stale/empty table rendered.
        this.empReportsQtys = [];
        this.empReportPrices[0].prices = [];
        this.tblReportsTotal = new EmpReportsTotal();
      }
    } catch (err) {
      console.error('Error fetching emp report table:', err);
      this.noTableData = true;
      this.isLoadingTable = false;
    } finally {
      this.isLoadingTable = false;
    }
  }

  formatDate(date: any): string {
    return date.toISOString().split('T')[0]; // Extracts only the year-month-day part
  }

  /*create projection chart by hours*/
  createProjectionChartByHours(projection: any[]): any[] {
    const projectionChartByHours: any[] = [];
    const hourMap = new Map<string, number>();

    // Iterate through each projection
    projection.forEach((proj) => {
      const hour = new Date(proj.createdDt).getHours().toString(); // Extract hour portion

      // If hour already exists in map, update the quantity
      if (hourMap.has(hour)) {
        hourMap.set(hour, hourMap.get(hour)! + proj.qty);
      } else {
        hourMap.set(hour, proj.qty); // Add new hour to map
      }
    });

    // Convert map to array of objects
    hourMap.forEach((qty, hour) => {
      projectionChartByHours.push({ Hour: hour, Qty: qty });
    });

    return projectionChartByHours;
  }

  /*create projection chart by dates*/
  createProjectionChart(projection: any[]): any[] {
    const projectionChart: any[] = [];
    const projectionMap = new Map<string, number>();

    // Iterate through each projection
    projection.forEach((proj) => {
      const date = proj.createdDt.includes('T')
        ? proj.createdDt.split('T')[0]
        : proj.createdDt; // Extract date portion

      // If date already exists in map, update the quantity
      if (projectionMap.has(date)) {
        projectionMap.set(date, projectionMap.get(date)! + proj.qty);
      } else {
        projectionMap.set(date, proj.qty); // Add new date to map
      }
    });

    // Convert map to array of objects
    projectionMap.forEach((qty, date) => {
      projectionChart.push({ createdDt: date, Qty: qty });
    });

    return projectionChart;
  }

  /*  formate totalItems data for stack bar chart */
  generateStackChartData(): void {
    const uniquePrices = Array.from(
      new Set(
        this.empDashboardDetails.totalItems.map(
          (item: { price: any }) => item.price
        )
      )
    ).sort((a: any, b: any) => a - b);
    const uniqueStores = Array.from(
      new Set(
        this.empDashboardDetails.totalItems.map((item: { id: any }) => item.id)
      )
    );

    uniquePrices.forEach((price) => {
      const priceData: number[] = [];
      uniqueStores.forEach((store) => {
        const qty = this.empDashboardDetails.totalItems
          .filter(
            (item: { price: unknown; id: unknown }) =>
              item.price === price && item.id === store
          )
          .reduce((acc: any, curr: { qty: any }) => acc + curr.qty, 0);
        priceData.push(qty);
      });
      this.stackChartData.push(priceData);
    });
  }

  //preProduced data for stack bar chart
  generateStackChartDataPreProduced(): void {
    const uniquePrices = Array.from(
      new Set(
        this.empDashboardDetails.totalPreProduced.map(
          (item: { price: any }) => item.price
        )
      )
    ).sort((a: any, b: any) => a - b);

    const uniqueStores = Array.from(
      new Set(
        this.empDashboardDetails.totalPreProduced.map(
          (item: { id: any }) => item.id
        )
      )
    );

    this.empDashboardDetails.totalPreProduced.forEach((item: any) => {
      this.totalItemsPreProduced += item.qty;
    });

    uniquePrices.forEach((price) => {
      const priceData: number[] = [];
      uniqueStores.forEach((store) => {
        const qty = this.empDashboardDetails.totalPreProduced
          .filter(
            (item: { price: unknown; id: unknown }) =>
              item.price === price && item.id === store
          )
          .reduce((acc: any, curr: { qty: any }) => acc + curr.qty, 0);
        priceData.push(qty);
      });
      this.stackChartDataPreProduced.push(priceData);
    });
  }

  /*formate Report table data*/

  formateReportTableData(res: any) {
    const tableReport = res.report as EmpReportTable[];

    /* ---------------- Prices ---------------- */
    this.empReportPrices[0].prices = Array.from(
      new Set(tableReport.map((x) => x.price))
    ).sort((a, b) => a - b);

    this.empReportsQtys = [];

    /* ---------------- Grouping ---------------- */
    const groupByStore = this.storeId === 0;
    const groupMap = new Map<string, EmpReportQty>();

    tableReport.forEach((item) => {
      const key = groupByStore ? item.store : `${item.id}_${item.userName}`;

      if (!groupMap.has(key)) {
        const report = new EmpReportQty();
        report.id = item.id;
        report.name = groupByStore ? item.store : item.userName;
        report.store = item.store;
        report.qtyArray = [];
        report.pieces = 0;
        report.value = 0;
        report.hours = 0;
        report.apop = 0;
        report.valuePerHour = 0;

        groupMap.set(key, report);
      }

      groupMap.get(key)!.qtyArray.push({
        price: item.price,
        qty: item.qty,
        userName: item.userName,
        hours: Math.abs(item.totalHoursLogged)
      });
    });

    /* ---------------- Row Calculations ---------------- */
    groupMap.forEach((empReport) => {
      empReport.pieces = empReport.qtyArray.reduce((sum, x) => sum + x.qty, 0);

      empReport.value = empReport.qtyArray.reduce(
        (sum, x) => sum + x.qty * x.price,
        0
      );

      empReport.apop = empReport.pieces
        ? empReport.value / empReport.pieces
        : 0;

      const uniqueHours = new Set<number>();
      empReport.qtyArray.forEach((x) => uniqueHours.add(x.hours));

      empReport.hours = Number(
        Array.from(uniqueHours)
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      );

      empReport.valuePerHour = empReport.hours
        ? empReport.value / empReport.hours
        : 0;

      this.empReportsQtys.push(empReport);
    });

    /* =======================
     TABLE TOTALS
  ======================= */
    this.tblReportsTotal = {
      pieces: 0,
      value: 0,
      hours: 0,
      valuePerHour: 0,
      apop: 0,
      totalQtyArray: []
    };

    this.empReportsQtys.forEach((r) => {
      this.tblReportsTotal.pieces += r.pieces || 0;
      this.tblReportsTotal.value += r.value || 0;
      this.tblReportsTotal.hours += r.hours || 0;

      r.qtyArray.forEach((q) => {
        const index = this.tblReportsTotal.totalQtyArray.findIndex(
          (x: any) => x.price === q.price
        );
        if (index !== -1) {
          this.tblReportsTotal.totalQtyArray[index].qty += q.qty;
          this.tblReportsTotal.totalQtyArray[index].hours += q.hours;
        } else {
          this.tblReportsTotal.totalQtyArray.push({ ...q });
        }
      });
    });

    this.tblReportsTotal.hours = Number(this.tblReportsTotal.hours.toFixed(2));

    this.tblReportsTotal.apop = this.tblReportsTotal.pieces
      ? this.tblReportsTotal.value / this.tblReportsTotal.pieces
      : 0;

    this.tblReportsTotal.valuePerHour = this.tblReportsTotal.hours
      ? this.tblReportsTotal.value / this.tblReportsTotal.hours
      : 0;
  }

  //format data for sheet
  formateReportExcelData(res: any) {
    const tableReport = res.report as EmpReportTable[];
    this.empReportPricesexcel[0].prices = Array.from(
      new Set(tableReport.map((item: EmpReportTable) => item.price))
    ).sort((a, b) => a - b);
    this.empReportsQtysexcel = [];

    // Stores unique userNames and storeNames
    const userNames: { username: string; storename: string }[] = [];

    tableReport.forEach((item) => {
      const username = String(item.userName); // Convert userName to string for consistency
      const storename = String(item.store); // Convert store to string for consistency

      // Check if the combination of username and storename already exists in the array
      const exists = userNames.some(
        (user) => user.username === username && user.storename === storename
      );

      if (!exists) {
        userNames.push({ username, storename });
      }
    });

    // Global map to track unique hours per user across all stores
    const globalUniqueHoursMap = new Map<string, number>();

    userNames.forEach((usernames) => {
      const storeData: any[] = tableReport.filter(
        (item) =>
          item.userName === usernames.username &&
          item.store === usernames.storename
      );
      const store: EmpReportQty = new EmpReportQty();
      store.id = storeData[0].id;
      store.name = storeData[0].userName; //this.storeId == 0 ? storeData[0].store : storeData[0].userName
      store.store = storeData[0].store;

      storeData.forEach((item) => {
        store.qtyArray.push({
          price: item.price,
          qty: item.qty,
          userName: item.userName,
          hours: Math.abs(item.totalHoursLogged)
        });
      });

      store.pieces = store.qtyArray.reduce((acc, curr) => acc + curr.qty, 0);
      store.value = store.qtyArray.reduce(
        (acc, curr) => acc + curr.price * curr.qty,
        0
      );
      store.apop = store.value / store.pieces;

      // Calculate unique hours per store
      const uniqueHoursMap = new Map<string, Set<number>>();

      store.qtyArray.forEach((curr) => {
        if (!uniqueHoursMap.has(curr.userName)) {
          uniqueHoursMap.set(curr.userName, new Set<number>());
        }
        uniqueHoursMap.get(curr.userName)?.add(curr.hours);
      });

      // Sum up all unique hours for the current store
      store.hours = parseFloat(
        Array.from(uniqueHoursMap.values())
          .reduce((acc: number, hoursSet: Set<number>) => {
            const sumOfHours = Array.from(hoursSet).reduce(
              (sum: number, hr: number) => sum + hr,
              0
            );
            return acc + sumOfHours;
          }, 0)
          .toFixed(2)
      );

      // Update the global map to track users already processed
      uniqueHoursMap.forEach((hoursSet, userName) => {
        const sumOfHours = Array.from(hoursSet).reduce(
          (sum, hr) => sum + hr,
          0
        );
        if (!globalUniqueHoursMap.has(userName)) {
          globalUniqueHoursMap.set(userName, sumOfHours);
        }
      });

      // Adjust store.hours to avoid duplicate counting for already processed users
      let adjustedHours = 0;
      store.qtyArray.forEach((item) => {
        if (globalUniqueHoursMap.has(item.userName)) {
          adjustedHours += globalUniqueHoursMap.get(item.userName)!;
          globalUniqueHoursMap.delete(item.userName); // Prevent future duplications
        }
      });
      store.hours = parseFloat(adjustedHours.toFixed(2));

      store.valuePerHour = store.hours ? store.value / store.hours : 0;
      // Calculate other properties as needed
      this.empReportsQtysexcel.push(store);
    });

    this.tblReportsTotal = new EmpReportsTotal();

    // Iterate through each EmpReportQty object
    this.empReportsQtysexcel.forEach((empReport) => {
      // Iterate through the qtyArray of each EmpReportQty
      empReport.qtyArray.forEach((item) => {
        // Find if the price already exists in totalQtyArray
        const index = this.tblReportsTotal.totalQtyArray.findIndex(
          (x) => x.price === item.price
        );

        // If the price exists, update its totalQty
        if (index !== -1) {
          this.tblReportsTotal.totalQtyArray[index].qty += item.qty;
          this.tblReportsTotal.totalQtyArray[index].hours += item.hours;
        }
        // If the price doesn't exist, add it to totalQtyArray
        else {
          this.tblReportsTotal.totalQtyArray.push({
            price: item.price,
            qty: item.qty,
            hours: item.hours
          });
        }
      });

      // Calculate other properties
      this.tblReportsTotalExcel.pieces += empReport.pieces;
      this.tblReportsTotalExcel.value += empReport.value;
      this.tblReportsTotalExcel.apop =
        this.tblReportsTotal.value / this.tblReportsTotal.pieces;
      this.tblReportsTotalExcel.hours += parseFloat(empReport.hours.toFixed(2));
      // Calculate valuePerHour
      this.tblReportsTotalExcel.valuePerHour = parseFloat(
        (this.tblReportsTotalExcel.hours
          ? this.tblReportsTotalExcel.value / this.tblReportsTotalExcel.hours
          : 0
        ).toFixed(2)
      );
    });
  }

  /* get qty associated with each prices*/

  getQuantity(qtyArray: any[] | undefined, price: number): number | string {
    const entry = qtyArray?.find((item) => item.price === price);
    return entry ? entry.qty : '-';
  }

  getFilterQuantity(qtyArray: any[] | undefined, price: number): number | null {
    if (!qtyArray) return null;

    const filteredItems = qtyArray.filter((item) => item.price === price);
    if (filteredItems.length === 0) return null;

    return filteredItems.reduce((sum, item) => sum + (item.qty || 0), 0);
  }

  getColumnWiseTotalPrices(
    qtyArray: any[] | undefined,
    price: number
  ): number | string {
    const entry = qtyArray?.find((item) => item.price === price);
    return entry ? entry.qty * entry.price : '-';
  }

  getColumnWiseHours(
    qtyArray: any[] | undefined,
    price: number
  ): number | string {
    const entry = qtyArray?.find((item) => item.price === price);
    return entry ? entry.hours : '-';
  }

  getColumnWiseValueperHour(
    qtyArray: any[] | undefined,
    price: number
  ): number | string {
    const entry = qtyArray?.find((item) => item.price === price);
    return entry
      ? (entry.hours ? (entry.qty * entry.price) / entry.hours : 0).toFixed(2)
      : '-';
  }

  /*  Charts*/

  renderChart() {
    this.destroy();

    Chart.register(...registerables);
    Chart.register(ChartDataLabels);

    let totalValue = new Chart('totalValue', {
      type: 'bar',
      data: {
        labels:
          this.empDashboardDetails?.totalValue?.map(
            (item: { name: any }) => item.name
          ) || [],
        datasets: [
          {
            label: 'Price',
            barThickness: 25,
            data:
              this.empDashboardDetails?.totalValue?.map(
                (item: { totalValue: any }) => item.totalValue
              ) || [],
            backgroundColor: [
              '#95A4FC',
              '#BAEDBD',
              '#1C1C1C',
              '#B1E3FF',
              '#A8C5DA'
            ],
            borderRadius: 8,
            borderSkipped: false
          }
        ]
      },
      options: {
        plugins: {
          legend: {
            display: false
          },
          datalabels: {
            display: false
          }
        },
        layout: {
          padding: {
            bottom: 0
          }
        },

        scales: {
          y: {
            beginAtZero: true,
            /* ticks: {
               stepSize: 5
             },
             max: Math.ceil(Math.max(...this.dashboardDetails.department.map((item: { QTY: any; }) => item.QTY)) / 5) * 5,*/
            border: {
              display: false
            }
          },

          x: {
            border: {
              display: false
            },
            grid: {
              display: false
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    });

    let totalItemCollectChart = new Chart('totalItem', {
      type: 'bar',
      data: {
        labels: this.stackChartLabels.map((item: string) => item),
        datasets: this.stackChartData.map((dataRow: number[], index) => ({
          data: [...dataRow],
          backgroundColor: this.getRandomColor(),
          label: 'No. of items',
          barThickness: 25,
          borderRadius: {
            bottomLeft: index == 0 ? 8 : 0,
            bottomRight: index == 0 ? 8 : 0,
            topLeft: index === this.stackChartData.length - 1 ? 8 : 0,
            topRight: index === this.stackChartData.length - 1 ? 8 : 0
          }
        }))
      },
      options: {
        plugins: {
          legend: {
            display: false
          },
          datalabels: {
            display: false
          }
        },
        scales: {
          x: {
            stacked: true,
            border: {
              display: false
            },
            grid: {
              display: false
            }
          },
          y: {
            stacked: true,
            border: {
              display: false
            }
          }
        },
        maintainAspectRatio: false,
        responsive: true
      }
    });
    let totalItemPreProducedChart = new Chart('preProduced', {
      type: 'bar',
      data: {
        labels: this.stackchartlabelsPreProduced.map((item: string) => item),
        datasets: this.stackChartDataPreProduced.map(
          (dataRow: number[], index) => ({
            data: [...dataRow],
            backgroundColor: this.getRandomColor(),
            label: 'No. of items',
            barThickness: 25,
            borderRadius: {
              bottomLeft: index == 0 ? 8 : 0,
              bottomRight: index == 0 ? 8 : 0,
              topLeft:
                index === this.stackChartDataPreProduced.length - 1 ? 8 : 0,
              topRight:
                index === this.stackChartDataPreProduced.length - 1 ? 8 : 0
            }
          })
        )
      },
      options: {
        plugins: {
          legend: {
            display: false
          },
          datalabels: {
            display: false
          }
        },
        scales: {
          x: {
            stacked: true,
            border: {
              display: false
            },
            grid: {
              display: false
            }
          },
          y: {
            stacked: true,
            border: {
              display: false
            }
          }
        },
        maintainAspectRatio: false,
        responsive: true
      }
    });

    let projectionChartData = new Chart('projection', {
      type: 'line',
      data: {
        labels: this.projectionLabels.map((item) => item),
        datasets: [
          {
            label: 'Qty',
            data: this.projectionChart.map((item: { Qty: any }) => item.Qty),
            backgroundColor: '#1C1C1C',
            borderColor: '#1C1C1C',
            pointRadius: 0,
            fill: false,
            tension: 0.1,
            borderWidth: 1
          },
          /*{
            label: '$',
            data: this.prevProjectionChart.map((item: { Qty: any }) => item.Qty),
            backgroundColor: '#FFA726',
            borderColor: '#FFA726',
            pointRadius: 0,
            fill: false,
            tension: 0.1,
            borderDash: [5, 5],
            borderWidth: 1
          },*/
          {
            label: 'Qty',
            data: this.prevProjectionChart.map(
              (item: { Qty: any }) => item.Qty
            ),
            backgroundColor: '#A8C5DA',
            borderColor: '#A8C5DA',
            pointRadius: 0,
            fill: false,
            tension: 0.1,
            borderDash: [5, 5],
            borderWidth: 1
          }
        ]
      },
      options: {
        plugins: {
          legend: {
            display: false
          },
          datalabels: {
            display: false
          }
        },
        scales: {
          x: {
            grid: {
              drawOnChartArea: false
            }
          },
          y: {
            grid: {
              drawOnChartArea: false
            },

            ticks: {
              stepSize: 20
            }
          }
        },
        maintainAspectRatio: false,
        clip: false,
        responsive: true,
        interaction: {
          intersect: false,
          mode: 'index'
        }
      }
    });

    this.charts = [
      totalValue,
      totalItemCollectChart,
      totalItemPreProducedChart,
      projectionChartData
    ];
  }

  destroy() {
    this.charts.forEach((chart) => {
      if (chart) {
        chart.destroy();
      }
    });

    if (this.projectionChartData) {
      this.projectionChartData.destroy();
    }
    if (this.totalItemCollectChart) {
      this.totalItemCollectChart.destroy();
    }
    if (this.totalItemPreProducedChart) {
      this.totalItemPreProducedChart.destroy();
    }

    this.charts = [];
  }

  destroyCharts() {
    this.totalValueCollected = 0;
    this.totalItemsCollected = 0;
    this.totalItemsPreProduced = 0;
    this.stackChartData = [];
    this.stackChartDataPreProduced = [];
    this.empLevel = [
      {
        StoreID: 0,
        name: '',
        Qty: 0,
        GoalCnt: 0,
        totalAchieved: 0,
        color: '',
        bg: ''
      }
    ];
    this.prevProjectionChart = [];
    this.projectionLabels = [];
    this.projectionChart = [];

    this.charts.forEach((chart) => {
      if (chart) {
        chart.destroy();
      }
    });

    if (this.projectionChartData) {
      this.projectionChartData.destroy();
    }
    if (this.totalItemCollectChart) {
      this.totalItemCollectChart.destroy();
    }
    if (this.totalItemPreProducedChart) {
      this.totalItemPreProducedChart.destroy();
    }

    this.charts = [];
  }

  changeSalesData(item: string, i: number) {
    this.reportTypeOption = item;
    if (i == 0) {
      this.isSummary = false;
    } else {
      if (i == 1) {
        this.isUser = true;
        this.isSummary = true;
        this.outletOne = 'Nelson Wuckert';
        this.outletTwo = 'Kara Hane';
      } else {
        if (i == 2) {
          this.isUser = false;
          this.isSummary = true;
          this.outletOne = 'NYC - 01';
          this.outletTwo = 'NYC - 02';
        }
      }
    }
  }

  randomColor(): string {
    const colors = ['#95A4FC', '#BAEDBD', '#1C1C1C', '#B1E3FF', '#A8C5DA'];
    if (this.colorIndex === colors.length - 1) {
      this.colorIndex = 0;
    } else {
      this.colorIndex++;
    }
    return colors[this.colorIndex];
  }

  getRandomColor() {
    /*   let colors = ['#95a4fc', '#9fadfd', '#a9b7fe', '#b3c0ff', '#bec9ff', '#c8d2ff', '#d3dbff', '#dee4ff','#e9edff']*/
    let color = 'hsl(' + Math.random() * 360 + ', 100%, 75%)';
    return color;
  }

  /*export data to excel*/
  exportToExcel(): void {
    const formattedData: RowData[] = [];
    let totalPieces = 0;
    let totalValues = 0;
    let totalHours = 0;
    let totalValuePerHours = 0;
    // Retrieve the prices from the first set of prices in empReportPrices
    const prices = this.empReportPricesexcel[0].prices;

    // Initialize an object to hold totals for each price
    const totals: { [key: string]: number } = {};
    for (const price of prices) {
      totals[`$${price.toFixed(2)}`] = 0;
    }

    // Initialize an object to hold Hour for each price
    const Hour: { [key: string]: number } = {};
    for (const price of prices) {
      Hour[`$${price.toFixed(2)}`] = 0;
    }

    // Initialize an object to hold valueperhour for each price
    const ValuePerHour: { [key: string]: number } = {};
    for (const price of prices) {
      ValuePerHour[`$${price.toFixed(2)}`] = 0;
    }

    // Calculate total quantities and populate formattedData
    // Map to track globally processed users per store for hours calculation
    const processedUsers = new Map<string, number>();
    for (const item of this.empReportsQtysexcel) {
      const qtyData = this.getQtyForExcelPriceFormatting(item.qtyArray, prices);
      const HourData = this.getHourForExcelPriceFormatting(
        item.qtyArray,
        prices
      );
      //const valuePerHourData = this.getValuePerHourForExcelPriceFormatting(item.qtyArray, prices);
      const rowData: RowData = {
        //id: item.id,
        name: item.name,
        store: item.store,
        ...qtyData,
        pieces: item.pieces,
        value: item.value,
        hours: item.hours,
        valuePerHour: item.hours ? (item.value / item.hours).toFixed(2) : 0,
        apop: (item.value / item.pieces).toFixed(2)
      };
      totalPieces += item.pieces;
      totalValues += item.value;
      // Create a unique key using userName and store name
      const userStoreKey = `${item.name}`;

      // Add hours only if the userStoreKey is not already processed
      if (!processedUsers.has(userStoreKey)) {
        totalHours += item.hours;
        processedUsers.set(userStoreKey, item.hours); // Mark userStoreKey as processed
      }
      totalValuePerHours = Number(
        totalHours ? (totalValues / totalHours).toFixed(2) : 0
      );

      // Update totals for each price column
      for (const key of Object.keys(qtyData)) {
        if (key.startsWith('$')) {
          totals[key] += qtyData[key] !== '-' ? qtyData[key] : 0;
        }
      }

      // Update Hour for each price column
      for (const key of Object.keys(HourData)) {
        if (key.startsWith('$')) {
          Hour[key] += HourData[key] !== '-' ? HourData[key] : 0;
        }
      }

      //// Update value per Hour for each price column
      //for (const key of Object.keys(valuePerHourData)) {
      //  if (key.startsWith('$')) {
      //    ValuePerHour[key] += valuePerHourData[key] !== '-' ? valuePerHourData[key] : 0;
      //  }
      //}

      formattedData.push(rowData);
    }

    // Add rows for total quantities
    const totalQtyRow: RowData = {
      id: 0,
      name: 'Totals',
      ...totals,
      pieces: totalPieces,
      value: totalValues,
      hours: totalHours,
      valuePerHour: Number(totalValuePerHours.toFixed(2)),
      apop: totalValues / totalPieces
    };
    formattedData.push(totalQtyRow);

    // Add row for total quantity * price
    const totalValueRow: RowData = {
      id: 0,
      name: 'Value',
      ...this.calculateTotalValue(totals, prices)
    };
    formattedData.push(totalValueRow);

    const totalQtyRow1: RowData = {
      id: 0,
      name: 'Pieces',
      ...totals
    };
    formattedData.push(totalQtyRow1);

    // Add row for Hour
    const hour: RowData = {
      id: 0,
      name: 'Hour',
      ...Hour
    };
    formattedData.push(hour);

    this.getValuePerHourForExcelPriceFormatting(
      ValuePerHour,
      Hour,
      totals,
      prices
    );

    // Add row for $/Hour
    const ratePerHourRow: RowData = {
      id: 0,
      name: '$/Hour',
      ...ValuePerHour
    };
    formattedData.push(ratePerHourRow);
    this.exportExcelService.exportAsExcelFile(formattedData, 'employee-report');
  }

  fillWithZeroes(prices: number[]): any {
    const result: { [key: string]: number } = {};
    for (let i = 0; i < prices.length; i++) {
      result[`$${prices[i].toFixed(2)}`] = prices[i];
    }
    return result;
  }

  calculateTotalValue(
    totals: { [key: string]: number },
    prices: number[]
  ): any {
    const result: { [key: string]: number | string } = {};

    for (const price of prices) {
      const totalQty = totals[`$${price.toFixed(2)}`];
      result[`$${price.toFixed(2)}`] = totalQty !== 0 ? totalQty * price : '-';
    }

    return result;
  }

  getQtyForExcelPriceFormatting(qtyArray: any[], prices: number[]): any {
    const result: any = {};

    for (const price of prices) {
      // Get quantity for the current item and price
      const qty = this.getQuantity(qtyArray, price);
      // Assign quantity to the corresponding price column
      result[`$${price.toFixed(2)}`] = qty !== null ? qty : '-';
    }

    return result;
  }

  getHourForExcelPriceFormatting(qtyArray: any[], prices: number[]): any {
    const result: any = {};
    for (const price of prices) {
      // Get hour for the current item and price
      const hr = this.getColumnWiseHours(qtyArray, price);
      // Assign hour to the corresponding price column
      result[`$${price.toFixed(2)}`] = hr !== null ? hr : '-';
    }

    return result;
  }

  getValuePerHourForExcelPriceFormatting(
    valuePerhours: { [key: string]: number },
    hours: { [key: string]: number },
    totals: { [key: string]: number },
    prices: number[]
  ): any {
    const result: { [key: string]: number | string } = {};

    for (let price of prices) {
      const priceKey = `$${price.toFixed(2)}`;
      const totalQty = totals[priceKey] || 0;

      result[priceKey] = totalQty !== 0 ? totalQty * price : '-';

      if (typeof result[priceKey] === 'number') {
        const totalValue = result[priceKey] as number;
        const hour = hours[priceKey] || 1;

        valuePerhours[priceKey] = parseFloat((totalValue / hour).toFixed(2));
      } else {
        valuePerhours[priceKey] = 0;
      }
    }

    return result;
  }

  onDateRangeSelected(date: DateRangeModel) {
    if (date.hour == true) {
      if (
        date.hourModel.isnPreviousHourWithDate == true &&
        typeof date.hourModel.nPreviousPeriodHourWithDate === 'string'
      ) {
        //Number.isInteger(parseInt(nPreviousYear, 10))
        let numValue = date.hourModel.nPreviousPeriodHourWithDate;
        if (this.containsSpecialCharacters(numValue)) {
          this.toaster.error('Invalid input');
          return;
        }
        // if date.hourModel.nPreviousPeriodHourWithDate < 0 || !Number.isInteger(date.hourModel.nPreviousPeriodHourWithDate)){
        //  this.toaster.error('Invalid input');
        //   return;
        // }
      }
      if (
        date.hourModel.isnPreviousHourWithDate == false &&
        typeof date.hourModel.nPreviousHour === 'string'
      ) {
        // if((date.hourModel.nPreviousHour < 0 || !Number.isInteger(date.hourModel.nPreviousHour))){
        //   this.toaster.error('Invalid input');
        //   return;
        // }
        let numValue = date.hourModel.nPreviousHour;
        if (this.containsSpecialCharacters(numValue)) {
          this.toaster.error('Invalid input');
          return;
        }
      }
    }
    if (date.day == true) {
      if (
        date.dayModel.isnPreviousDayWithDate == true &&
        typeof date.dayModel.nPreviousPeriodDayWithDate === 'string'
      ) {
        // if(date.dayModel.nPreviousPeriodDayWithDate < 0 || !Number.isInteger(date.dayModel.nPreviousPeriodDayWithDate)){
        //   this.toaster.error('Invalid input');
        //   return;
        // }
        let numValue = date.dayModel.nPreviousPeriodDayWithDate;
        if (this.containsSpecialCharacters(numValue)) {
          this.toaster.error('Invalid input');
          return;
        }
      }
      if (
        date.dayModel.isnPreviousDayWithDate == false &&
        typeof date.dayModel.nPreviousDay === 'string'
      ) {
        // if((date.dayModel.nPreviousDay < 0 || !Number.isInteger(date.dayModel.nPreviousDay))){
        //   this.toaster.error('Invalid input');
        //   return;
        // }
        let numValue = date.dayModel.nPreviousDay;
        if (this.containsSpecialCharacters(numValue)) {
          this.toaster.error('Invalid input');
          return;
        }
      }
    }

    if (date.week == true) {
      if (
        date.weekModel.isnPreviousWeekWithDate == true &&
        typeof date.weekModel.nPreviousPeriodWeekWithDate === 'string'
      ) {
        // if(date.weekModel.nPreviousPeriodWeekWithDate < 0 || !Number.isInteger(date.weekModel.nPreviousPeriodWeekWithDate)){
        //   this.toaster.error('Invalid input');
        //   return;
        // }
        let numValue = date.weekModel.nPreviousPeriodWeekWithDate;
        if (this.containsSpecialCharacters(numValue)) {
          this.toaster.error('Invalid input');
          return;
        }
      }
      if (
        date.weekModel.isnPreviousWeekWithDate == false &&
        typeof date.weekModel.nPreviousWeek === 'string'
      ) {
        // if((date.weekModel.nPreviousWeek < 0 || !Number.isInteger(date.weekModel.nPreviousWeek))){
        //   this.toaster.error('Invalid input');
        //   return;
        // }
        let numValue = date.weekModel.nPreviousWeek;
        if (this.containsSpecialCharacters(numValue)) {
          this.toaster.error('Invalid input');
          return;
        }
      }
    }
    if (date.month == true) {
      if (
        date.monthModel.isnPreviousMonthWithDate == true &&
        typeof date.monthModel.nPreviousPeriodMonthWithDate === 'string'
      ) {
        // if(date.monthModel.nPreviousPeriodMonthWithDate < 0 || !Number.isInteger(date.monthModel.nPreviousPeriodMonthWithDate)){
        //   this.toaster.error('Invalid input');
        //   return;
        // }
        let numValue = date.monthModel.nPreviousPeriodMonthWithDate;
        if (this.containsSpecialCharacters(numValue)) {
          this.toaster.error('Invalid input');
          return;
        }
      }
      if (
        date.monthModel.isnPreviousMonthWithDate == false &&
        typeof date.monthModel.nPreviousMonth === 'string'
      ) {
        // if((date.monthModel.nPreviousMonth < 0 || !Number.isInteger(date.monthModel.nPreviousMonth))){
        //   this.toaster.error('Invalid input');
        //   return;
        // }
        let numValue = date.monthModel.nPreviousMonth;
        if (this.containsSpecialCharacters(numValue)) {
          this.toaster.error('Invalid input');
          return;
        }
      }
    }
    if (date.quarter == true) {
      if (
        date.quarterModel.isnPreviousQuarterWithDate == true &&
        typeof date.quarterModel.nPreviousPeriodQuarterWithDate === 'string'
      ) {
        // if(date.quarterModel.nPreviousPeriodQuarterWithDate < 0 || !Number.isInteger(date.quarterModel.nPreviousPeriodQuarterWithDate)){
        //   this.toaster.error('Invalid input');
        //   return;
        // }
        let numValue = date.quarterModel.nPreviousPeriodQuarterWithDate;
        if (this.containsSpecialCharacters(numValue)) {
          this.toaster.error('Invalid input');
          return;
        }
      }
      if (
        date.quarterModel.isnPreviousQuarterWithDate == false &&
        typeof date.quarterModel.nPreviousQuarter === 'string'
      ) {
        // if((date.quarterModel.nPreviousQuarter < 0 || !Number.isInteger(date.quarterModel.nPreviousQuarter))){
        //   this.toaster.error('Invalid input');
        //   return;
        // }
        let numValue = date.quarterModel.nPreviousQuarter;
        if (this.containsSpecialCharacters(numValue)) {
          this.toaster.error('Invalid input');
          return;
        }
      }
    }
    if (date.year == true) {
      if (
        date.yearModel.isnPreviousYearWithDate == true &&
        typeof date.yearModel.nPreviousPeriodYearWithDate === 'string'
      ) {
        // if(date.yearModel.nPreviousPeriodYearWithDate < 0 || !Number.isInteger(date.yearModel.nPreviousPeriodYearWithDate)){
        //   this.toaster.error('Invalid input');
        //   return;
        // }
        let numValue = date.yearModel.nPreviousPeriodYearWithDate;
        if (this.containsSpecialCharacters(numValue)) {
          this.toaster.error('Invalid input');
          return;
        }
      }
      if (
        date.yearModel.isnPreviousYearWithDate == false &&
        typeof date.yearModel.nPreviousYear === 'string'
      ) {
        // if((date.yearModel.nPreviousYear < 0 || !Number.isInteger(date.yearModel.nPreviousYear))){
        //   this.toaster.error('Invalid input');
        //   return;
        // }
        let numValue = date.yearModel.nPreviousYear;
        if (this.containsSpecialCharacters(numValue)) {
          this.toaster.error('Invalid input');
          return;
        }
      }
    }
    const currentTime = new Date(date.toDate);
    this.dateRangeModal = date;
    //this.filterreportnew();
    this.selectedDate();
  }

  containsSpecialCharacters(value: any) {
    // Regular expression to match special characters
    const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;
    // Test if the value contains special characters
    return specialCharPattern.test(value);
  }

  validateInteger(value: any) {
    // Trim the value to remove any leading/trailing whitespace
    const trimmedValue = value.trim();
    // Check if the value is an empty string

    if (trimmedValue === '') {
      return false;
    }
    const parsedValue = parseInt(trimmedValue, 10);
    if (
      Number.isInteger(parsedValue) &&
      trimmedValue === parsedValue.toString()
    ) {
      return true;
    } else {
      return false;
    }
  }

  get pagedEmpReports() {
    return this.empReportsQtys.slice(0, this.currentPage * this.pageSize);
  }

  get remainingCount() {
    const remaining =
      this.empReportsQtys.length - this.currentPage * this.pageSize;
    return remaining > 0 ? Math.min(remaining, this.pageSize) : 0;
  }

  loadMore() {
    this.currentPage++;
    this.isLoadingTable = true;
    this.isLoadingEmpDashboard = true;

    setTimeout(() => {
      this.isLoadingTable = false;
      this.isLoadingEmpDashboard = false;
    }, 500);
  }
}
